/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Container from "@mui/material/Container";

// Material Dashboard 2 PRO React examples
import PageLayout from "examples/LayoutContainers/PageLayout";

// Pricing page components
import Header from "layouts/invoicing/pricing_page/components/Header";
import Footer from "layouts/invoicing/pricing_page/components/Footer";
import PricingCards from "layouts/invoicing/pricing_page/components/PricingCards";
import TrustedBrands from "layouts/invoicing/pricing_page/components/TrustedBrands";
import Faq from "layouts/invoicing/pricing_page/components/Faq";

function PricingPage() {
  const [tabValue, setTabValue] = useState(0);
  const [prices, setPrices] = useState(["Free", "89", "99"]);

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
    if (event.currentTarget.id === "annual") {
      setPrices(["119", "159", "399"]);
    } else {
      setPrices(["Free", "89", "99"]);
    }
  };

  return (
    <PageLayout>
      
      <Header tabValue={tabValue} tabHandler={handleSetTabValue}>
        <Container>
          <PricingCards prices={prices} tabValue={tabValue} />
          {/* <TrustedBrands /> */}
          <Faq />
        </Container>
      </Header>
    </PageLayout>
  );
}

export default PricingPage;
